import { usePageCapabilities } from "../../Shared/usePageCapabilities";

export function useYourDiscourseCapabilities(authenticatedUser) {
  const capabilities = {
    showAdminDiscourseNavigation: authenticatedUser?.canAdministerDocuments,
    showPublishedDiscourseNavigation: authenticatedUser?.inDiscourseExperiment,
    showYourDiscourseNavigation: false,
    showNewDiscourseNavigation: authenticatedUser?.inDiscourseExperiment,
  };

  usePageCapabilities(capabilities, []);
}